import React from 'react';
import './InsigneCoins.css';

import useInsigneCoins from "../../../hooks/useInsigneCoins";

function InsigneCoins() {

  const { insigneCoins, loading, error } = useInsigneCoins();
  if(loading){
    return <>Carregando...</>;
  }
  return (
    <div className='insigneCoins-container'>
        <h2>Insigne Coins</h2>
        <p>Você atualmente possui <strong>{insigneCoins?.insignecoins} Insigne Coins.</strong></p>
    </div>
  );
}

export default InsigneCoins;
